import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

// Find all order labels for split (dropdown list)
export const findAllOrderLabelSplit = createAsyncThunk(
  "SplitItem/FindAllOrderLableSplit",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Order/FindAllOrderLableSplit`,
      );
      return response.data?.Data || [];
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching order label splits:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

const mergeOrderLabeling = (result: any) => {
  if (result) {
    const totalLessWeight =
      result.ORDERLabeling?.length > 0
        ? result.ORDERLabeling?.reduce((acc: any, item: any) => {
            return acc + Number(item?.Weight || 0);
          }, 0)
        : 0;
    result.GrossWeight = result.GrossWeight || 0;
    result.LessWeight =
      result.LessWeight || result.ORDERLabeling?.length > 0
        ? totalLessWeight
        : 0;
    result.NetWeight = result.GrossWeight - totalLessWeight || 0;
    result.ORDERLabeling =
      result.ORDERLabeling?.length > 0
        ? result.ORDERLabeling?.reduce((acc: any[], item: any) => {
            const finditem = acc.find((aci: any) => aci.ItemID === item.ItemID);
            if (finditem) {
              finditem.Weight = Number(
                ((finditem.Weight || 0) + (item.Weight || 0)).toFixed(3),
              );
              finditem.Pcs = (finditem.Pcs || 0) + (item.Pcs || 0);
              if (finditem.Total !== undefined || item.Total !== undefined) {
                finditem.Total = (finditem.Total || 0) + (item.Total || 0);
              }
              if (finditem.total !== undefined || item.total !== undefined) {
                finditem.total = (finditem.total || 0) + (item.total || 0);
              }
            } else {
              acc.push({
                ...item,
                id: item.id,
              });
            }
            return acc;
          }, [])
        : [];
  }
  return result;
};

// Get data by unique product ID
export const getDataByUniqueProductID = createAsyncThunk(
  "SplitItem/DataByUniqueProductID",
  async (request: { UniqueProductID: string }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Order/DataByUniqueProductID`,
        request,
      );
      const result = response.data?.Data || null;
      return mergeOrderLabeling(result);
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching data by unique product ID:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Insert order label split
export const insertOrderLabelSplit = createAsyncThunk(
  "SplitItem/InsertOrderLableSplit",
  async (request: { ReadyData: any[] }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Order/InsertOrderLableSplit`,
        request,
      );
      SuccessToast(
        response.data?.Details || "Order label split inserted successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting order label split:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Find by ID order label split
export const findByIDOrderLabelSplit = createAsyncThunk(
  "SplitItem/FindByIDOrderLableSplit",
  async (request: { ID: number }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Order/FindByIDOrderLableSplit`,
        request,
      );
      const result = response.data?.Data || null;
      return mergeOrderLabeling(result);
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching order label split by ID:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
